export interface UploadUrlRequestBody {
    name: string;
    type: string;
    fileType?: string;
    forceReplace?: boolean;
    contentType?: string;
    public?: boolean;
};

export interface NoticedBackendRequestBody {
    name: string;
    replace?: boolean;
    fileType?: string;
    modelKey?: string;
    public?: boolean;
    downloadUrl?: string;
    provider?: string;
};

export interface ShareFileRequestBody {
    usernames: Array<string>;
};

export interface AckFileRequestBody {
    ackReceived: boolean;
};